import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAboutUs } from "../redux/aboutSlice";

export default function useAboutData() {
    const dispatch = useDispatch();
    const { data, loading, error } = useSelector((state) => state.about);

    useEffect(() => {
        document.title = "Obsession - About Us";

        // Prevent unnecessary API calls
        if (!data && !loading) {
            dispatch(fetchAboutUs());
        }
    }, [dispatch, data, loading]);

    return { data, loading, error };
}
